export default __webpack_public_path__ + "KaTeX_Main-BoldItalic.b345de5bd14864bcefbff8f92de7a1c8.woff2";